var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAircraftTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22.652 28.787 17.092 18.2l-5.535 5.536.507 3.554-1.498 1.498-2.539-4.52-4.496-2.514 1.499-1.499 3.505.46 5.536-5.536L3.53 9.666l1.982-1.982 13.078 2.973 5.536-5.536a2.05 2.05 0 0 1 1.499-.628q.87 0 1.523.652.652.654.64 1.511a2.08 2.08 0 0 1-.64 1.487l-5.536 5.536 3.022 13.126-1.983 1.982z"
})));
export default SvgAircraftTable;